import type { DateTime } from 'luxon'
import { DateTime as LuxonDateTime } from 'luxon'

import type { SeriesPageSession } from '@/common/services/seriesPage/types'

// The banners previously each ran their own
// `getSessions(... end_date > CURRENT_TIMESTAMP) LIMIT 1` scope. Sessions arrive in
// start-date order, so the same choice is a find over the payload. `now` comes from the
// caller (useServerNow) so this uses the server clock rather than the browser's.
//
// Timestamps are parsed rather than string-compared: payload values carry timezone
// offsets, so lexical ordering is not chronological ordering.
export function findNextSession(
  sessions: SeriesPageSession[],
  now: DateTime
): SeriesPageSession | null {
  return sessions.find(session => LuxonDateTime.fromISO(session.endDate) > now) ?? null
}
